import { mergeObjectTypes } from '../cacheHelpers';

const CalculatedInfo = {
  merge: mergeObjectTypes
};

export default CalculatedInfo;
